import { PdfPages } from "./PdfPages";
import { PDF_EXPORT_ROOT_ID } from "./pdfDimensions";
import type { ReportPdfModel } from "./reportTypes";
import "./pdf-pages.css";
import "./pdf-print.css";
import "./report-typography.css";

type PdfExportProps = {
  model: ReportPdfModel;
  /** Show off-screen capture tree on screen (debug / autopdf preview) */
  visible?: boolean;
};

export function PdfExport({ model, visible = false }: PdfExportProps) {
  return (
    <>
      <div
        id="pdf-export-status"
        aria-live="polite"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: 1,
          height: 1,
          opacity: 0.01,
          pointerEvents: "none",
        }}
      />
      <div
        id={PDF_EXPORT_ROOT_ID}
        className={visible ? "pdf-export-root--visible" : undefined}
        aria-hidden={!visible}
      >
        <PdfPages model={model} />
      </div>
    </>
  );
}
